import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_2 = { class: "max-width-1-screen" }

import HeaderLogo from '@/components/HeaderLogo.vue';
import connectivityToast from '@/components/connectivityToast.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationProcess',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderLogo),
    _createVNode(connectivityToast),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterView)
    ])
  ]))
}
}

})